import { ThemedStyleFn } from '~src/hooks/useStyles';

export const styleFn: ThemedStyleFn = (theme) => ({
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px',
  },
  plusIcon: {
    fontSize: 25,
    color: theme.colors.primary,
  },
});
